import initInhouseTrainingOnModalOpen from './inhouseTrainingOnModalOpen';
import initInhouseTrainingFormOnSubmit from './inhouseTrainingFormOnSubmit';
import initRemoveIsInvalid from './removeIsInvalid';
import initRemainingCharacterForText from './remainingCharacterForText';
import initShowHideTeamSize from './showHideTeamSize';

export default () => {
  initInhouseTrainingOnModalOpen();
  initInhouseTrainingFormOnSubmit();
  initRemoveIsInvalid();
  initRemainingCharacterForText();
  initShowHideTeamSize();
};
